'use strict';

var selectors = {
  sliders: '.pageLearn_posts'
};

if (window.innerWidth < 768) {
  mobileOnlySlider();
}

$(window).resize(function (e) {
  if (window.innerWidth < 768) {
    if (!$($(selectors.sliders)[0]).hasClass('slick-initialized')) {
      mobileOnlySlider();
    }
  } else {
    if ($($(selectors.sliders)[0]).hasClass('slick-initialized')) {
      $(selectors.sliders).slick('unslick');
    }
  }
});

function mobileOnlySlider() {
  var sliderId, autoplay;
  autoplay = false;
  $(selectors.sliders).slick({
    slide: ".blogPost_item",
    slidesToShow: 1,
    centerMode: false,
    //centerPadding: '5%',
    dots: false,
    infinite: true,
    arrows: true,
    adaptiveHeight: false,
    autoplay: autoplay,
    zIndex: 100,
    rows: 0
  });
}